module.exports = __webpack_public_path__ + "static/media/en.f464c91c.svg";